import { canonicalLineType } from "../lineType";

export function canViewPwgRow(row, capabilities = {}) {
  const type = canonicalLineType(row);
  // Regular, Goblin, and Demon are the uniform customer line-type contract for
  // every sport. Capabilities still govern advanced analysis/presentation,
  // while the shared filter determines which variant is visible.
  if (["regular", "goblin", "demon"].includes(type)) return true;
  if (type === "promo") return capabilities.promoLines === true;
  // UNKNOWN is legacy/unclassified data. Keep it available but suppressed in
  // presentation; never infer that it is PRIMARY.
  return type === "unknown";
}

export function pwgGuruModeView(capabilities = {}) {
  return Object.freeze({
    enabled: capabilities.pwgGuruMode === true,
    alternateLines: capabilities.pwgAlternateLines === true,
    goblinLines: capabilities.pwgGoblinLines === true,
    demonLines: capabilities.pwgDemonLines === true,
    promoLines: capabilities.pwgPromoLines === true,
    lineTypeFilters: capabilities.pwgLineTypeFilters === true,
    attainability: capabilities.pwgAttainability === true,
    primaryLineComparison: capabilities.pwgPrimaryLineComparison === true,
    advancedFilters: capabilities.pwgAdvancedFilters === true,
  });
}
